export enum InvitationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
}
export enum InvitationType {
  PROJECT = 'PROJECT',
  WORKSPACE = 'WORKSPACE',
  ORGANIZATION = 'ORGANIZATION',
}

import { AC_Organization_Role } from '../services/access_control/AC_Organization';
import { AC_Project_Role } from '../services/access_control/AC_Project';
import { Organization_Base } from './Organization';
import { Project_Base } from './Project';
import { StrapiModel_Base } from './StrapiModel';
import { User_Base } from './User';

export type Invitation_Base = StrapiModel_Base &{
  from: User_Base,
  to: User_Base,
  type: InvitationType,
  project?: Project_Base,
  organization?: Organization_Base,
  status: InvitationStatus,
  role: AC_Project_Role | AC_Organization_Role,
};
